<div *ngIf="this.tussentellingenFg.get(['totaalBijdrageInkomen'])?.value !== 0 || this.aangifteBerekening.verschuldigdeZVW?.valueOf() !== 0">

    <div *ngIf="this.rapport.specificatieZvw?.opbouw?.loonHogerDanMaximumBijdrageInkomen">
        <p>Het loon waarover al premies zorgverzekeringswet is afgedragen bedraagt
            € {{ this.rapport.specificatieZvw?.opbouw?.loonWaaroverIsGeheven?.valueOf() | number: '1.0-0' }}.<br/>
            Dat is hoger dan het maximum bijdrage-inkomen voor het jaar {{ this.year }} van
            € {{ this.tussentellingenFg.get(['maxPremieLoon'])?.value | number: '1.0-0' }}.<br/></p>
        Er is geen aanvullende premie zorgverzekeringswet verschuldigd.
    </div>

    <div *ngIf="this.rapport.specificatieZvw?.opbouw?.loonHogerDanMaximumBijdrageInkomen === false ||
                this.rapport.specificatieZvw?.opbouw?.loonHogerDanMaximumBijdrageInkomen === null ||
            this.rapport.specificatieZvw?.opbouw?.loonHogerDanMaximumBijdrageInkomen === undefined">

        <form [formGroup]="berekeningFormGroup">
            <div class="row">
                <div formGroupName="box1">
                    <div formGroupName="opbouwInkomen">
                        <div *ngIf="this.berekeningFormGroup.get(['box1', 'opbouwInkomen', 'winstUitOnderneming' ])?.value !== null">
                            <div class="row">
                                <div class="col col-1">
                                    @if(this.rapportFormGroup
                                        .get(['specificatieZvw', 'opbouw', 'loonAlsOnderdeelVanWinst'])?.value > 0) {
                                        <p>Winst uit onderneming (excl. loon)</p>
                                    } @else {
                                        <p>Winst uit onderneming</p>
                                    }

                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control [decimals]="0"
                                                                      align="right"
                                                                      class="custom-input-150"
                                                                      formControlName="winstUitOnderneming"
                                                                      prefix="€"
                                    >
                                    </snelstart-ui-number-form-control>
                                </div>
                                <div class="col-4"></div>
                                <div class="col-4"></div>
                            </div>
                        </div>
                        <div *ngIf="this.rapportFormGroup.get(['specificatieROW', 'opbouw', 'inkomstenUitOVerigeWerkzaamheden' ])?.value !== null ||
                                    this.rapportFormGroup.get(['specificatieROW', 'opbouw', 'kostenTerZakeVanOverigeWerkzaamheden' ])?.value !== null">
                            <div class="row">
                                <div class="col col-1">
                                    <p>Resultaat overige werkzaamheden</p>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control [decimals]="0"
                                                                      align="right"
                                                                      class="custom-input-150"
                                                                      formControlName="resultaatUitOverigeWerkzaamheden"
                                                                      prefix="€"
                                    >
                                    </snelstart-ui-number-form-control>
                                </div>
                                <div class="col-4"></div>
                                <div class="col-4"></div>
                            </div>
                        </div>
                        <div *ngIf="this.berekeningFormGroup.get(['box1', 'opbouwInkomen', 'periodiekeUitkeringen' ])?.value !== null">
                            <div class="row">
                                <div class="col col-1">
                                    <p>Periodieke uitkeringen</p>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control [decimals]="0"
                                                                      align="right"
                                                                      class="custom-input-150"
                                                                      formControlName="periodiekeUitkeringen"
                                                                      prefix="€"
                                    >
                                    </snelstart-ui-number-form-control>
                                </div>
                                <div class="col-4"></div>
                                <div class="col-4"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <form [formGroup]="rapportFormGroup">
            <div class="row">
                <div formGroupName="specificatieZvw">
                    <div formGroupName="opbouw">
                        <div *ngIf="this.rapportFormGroup.get(['specificatieZvw', 'opbouw', 'loonWaaroverIsGeheven' ])?.value !== 0">
                            <div class="row">
                                <div class="col col-1">
                                    <p>Loon waarover premie Zorgverzekeringswet is berekend</p>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control [decimals]="0"
                                                                      align="right"
                                                                      class="custom-input-150"
                                                                      prefix="€"
                                                                      formControlName="loonWaaroverIsGeheven">
                                    </snelstart-ui-number-form-control>
                                </div>
                                <div class="col-4"></div>
                                <div class="col-4"></div>
                            </div>
                        </div>

                        <div *ngIf="this.rapportFormGroup.get(['specificatieZvw', 'opbouw', 'loonBuitenlandVoorZvw' ])?.value !== null">
                            <div class="row">
                                <div class="col col-1">
                                    <p>Buitenlands loon</p>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control [decimals]="0"
                                                                      align="right"
                                                                      class="custom-input-150"
                                                                      formControlName="loonBuitenlandVoorZvw"
                                                                      prefix="€"
                                    >
                                    </snelstart-ui-number-form-control>
                                </div>
                                <div class="col-4"></div>
                                <div class="col-4"></div>
                            </div>
                        </div>
                        <div *ngIf="this.rapportFormGroup.get(['specificatieZvw', 'opbouw', 'vrijgesteldLoonVoorZvw' ])?.value !== null">
                            <div class="row">
                                <div class="col col-1">
                                    <p>Vrijgestelde loon</p>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control [decimals]="0"
                                                                      align="right"
                                                                      class="custom-input-150"
                                                                      formControlName="vrijgesteldLoonVoorZvw"
                                                                      prefix="€"
                                    >
                                    </snelstart-ui-number-form-control>
                                </div>
                                <div class="col-4"></div>
                                <div class="col-4"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div formGroupName="specificatieLijfrente">
                    <div formGroupName="opbouw">
                        <div *ngIf="this.rapportFormGroup.get(['specificatieLijfrente', 'opbouw', 'premieAfstortingFor' ])?.value !== null &&
                                                             this.rapportFormGroup.get(['specificatieLijfrente', 'opbouw', 'premieAfstortingFor' ])?.value > 0">
                            <div class="row">
                                <div class="col col-1">
                                    <p>Af: Premie lijfrente in verband met afname fiscale oudedagsreserve</p>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control [decimals]="0"
                                                                      align="right"
                                                                      class="custom-input-150"
                                                                      formControlName="premieAfstortingFor"
                                                                      prefix="€ -"
                                    >
                                    </snelstart-ui-number-form-control>
                                </div>
                                <div class="col-4"></div>
                                <div class="col-4"></div>
                            </div>
                        </div>
                        <div *ngIf="this.rapportFormGroup.get(['specificatieLijfrente', 'opbouw', 'premieOmzettingForBijStaking' ])?.value !== null &&
                                                             this.rapportFormGroup.get(['specificatieLijfrente', 'opbouw', 'premieOmzettingForBijStaking' ])?.value > 0">
                            <div class="row">
                                <div class="col col-1">
                                    <p>Af: Premie lijfrente in verband met afname fiscale oudedagsreserve bij
                                        staking</p>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control [decimals]="0"
                                                                      align="right"
                                                                      class="custom-input-150"
                                                                      formControlName="premieOmzettingForBijStaking"
                                                                      prefix="€ -"
                                    >
                                    </snelstart-ui-number-form-control>
                                </div>
                                <div class="col-4"></div>
                                <div class="col-4"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <form [formGroup]="tussentellingenFg">
            <div class="row">
                <div class="col col-1" style="font-weight: bold">
                    <p>Totaal bijdrage-inkomen</p>
                </div>
                <div class="col-2">
                    <snelstart-ui-number-form-control [decimals]="0"
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="totaalBijdrageInkomen"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                </div>
                <div class="col-4"></div>
                <div class="col-4"></div>
            </div>
            <div *ngIf="this.tussentellingenFg.get('totaalBijdrageInkomen')?.value > this.tussentellingenFg.get('maxPremieLoon')?.value ">
                <div class="row">
                    <div class="col col-1">
                        <p>Maximum bijdrage-inkomen {{ this.year }}</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control [decimals]="0"
                                                          align="right"
                                                          class="custom-input-150"
                                                          formControlName="maxPremieLoon"
                                                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                    </div>
                    <div class="col-4"></div>
                    <div class="col-4"></div>
                </div>
            </div>
        </form>
        <div *ngIf="this.rapportFormGroup.get(['specificatieZvw', 'opbouw', 'loonWaaroverIsGeheven'])?.value > 0 ">
            <form [formGroup]="rapportFormGroup">
                <div formGroupName="specificatieZvw">
                    <div formGroupName="opbouw">
                        <div class="left">
                            <div class="row">
                                <div class="col col-1">
                                    <p>Loon waarover premie Zorgverzekeringswet is berekend</p>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control [decimals]="0"
                                                                      align="right"
                                                                      class="custom-input-150"
                                                                      formControlName="loonWaaroverIsGeheven"
                                                                      prefix="€ -"
                                    >
                                    </snelstart-ui-number-form-control>
                                </div>
                                <div class="col-4"></div>
                                <div class="col-4"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

            <form [formGroup]="tussentellingenFg">
                <div class="row">
                    <div class="col col-1">
                        <p>Totaal bijdrage-inkomen</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control [decimals]="0"
                                                          align="right"
                                                          class="custom-input-150"
                                                          formControlName="totaalBijdrageInkomenNaMaxEnLoon"
                                                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                    </div>
                    <div class="col-4"></div>
                </div>
            </form>

        </div>

        <form [formGroup]="tussentellingenFg">
            <div class="row pt-3">
                <div class="col col-1">
                    <p>Verschuldigde premie
                        zorgverzekeringswet: {{ this.tussentellingenFg.get('percentageZwv')?.value | number: '1.0-2' }}
                        % van
                        € {{ this.tussentellingenFg.get('totaalBijdrageInkomenNaMaxEnLoon')?.value | number: '1.0-0' }}</p>
                </div>
                <div class="col-2">
                    <snelstart-ui-number-form-control [decimals]="0"
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="verschuldigdePremie"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                </div>
                <div class="col-4"></div>
            </div>
        </form>

        <form [formGroup]="tussentellingenFg">
            <div class="row">
                <div class="col col-1 ">
                    <p>Af: Betaald via voorlopige aanslag(en)</p>
                </div>
                <div class="col-2">
                    <snelstart-ui-number-form-control [decimals]="0"
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="voorlopigeAanslagZvw"
                                                      id="voorlopigeAanslagZvw"
                                                      placeholder="-"
                                                      prefix="€ -"
                    >
                    </snelstart-ui-number-form-control>
                </div>
                <div class="col-4"></div>
            </div>
        </form>

        <form [formGroup]="berekeningFormGroup">
            <div class="row">
                <div class="col col-1" style="font-weight: bold">
                    <div *ngIf="!this.partnerBoolean">
                        <p *ngIf="(berekening?.verschuldigdeZVW ?? 0) < 0">Te
                            ontvangen door {{ dataService.naamAangever }}</p>
                        <p *ngIf="(berekening?.verschuldigdeZVW ?? 0) >= 0">Te
                            betalen door {{ dataService.naamAangever }}</p>
                    </div>
                    <div *ngIf="this.partnerBoolean">
                        <p *ngIf="(berekening?.verschuldigdeZVW ?? 0) < 0">Te
                            ontvangen door {{ dataService.naamPartner }}</p>
                        <p *ngIf="(berekening?.verschuldigdeZVW ?? 0) >= 0">Te
                            betalen door {{ dataService.naamPartner }}</p>
                    </div>
                </div>
                <div class="col-2">
                    <snelstart-ui-number-form-control [decimals]="0"
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="verschuldigdeZVW"
                                                      id="verschuldigdeZVW" prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                </div>
                <div class="col-4"></div>
            </div>
        </form>
    </div>

</div>

<div *ngIf="this.tussentellingenFg.get(['totaalBijdrageInkomen'])?.value === 0 && this.aangifteBerekening.verschuldigdeZVW?.valueOf() === 0">
    <div>
        Er is geen bijdrage-inkomen Zorgverzekeringswet.
    </div>
</div>


